<script>
	import IconSvg from './IconSvg.svelte';
    export let link
    export let styleClass=""

</script>

{#if link.iconId !== undefined}
    <IconSvg item={link} {styleClass} />
    {:else}
    <span data-val={link.icon} class="{styleClass} km-icon {GetFontClass(link.iconfont)}"></span>
{/if}